import React from 'react';

/**
 * Clickable 5-star rating selector.
 * Props: value (1-5 or 0), onChange(n), size, name (for hidden input)
 */
const StarRating = ({ value = 0, onChange, name = 'rating', testIdPrefix = 'star' }) => {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="star-rating" role="radiogroup" aria-label="Rating">
      {stars.map((n) => {
        const active = n <= value;
        return (
          <button
            key={n}
            type="button"
            className={`star-rating-cell ${active ? 'active' : ''}`}
            onClick={() => onChange(n)}
            aria-label={`${n} star${n > 1 ? 's' : ''}`}
            aria-checked={value === n}
            role="radio"
            data-testid={`${testIdPrefix}-${n}`}
          >
            <svg
              className="star-rating-svg"
              viewBox="0 0 24 24"
              fill={active ? 'currentColor' : 'none'}
              stroke="currentColor"
              strokeWidth="2"
              strokeLinejoin="round"
              strokeLinecap="round"
              aria-hidden="true"
            >
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
          </button>
        );
      })}
      <input type="hidden" name={name} value={value || ''} />
    </div>
  );
};

export default StarRating;
